import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { faqs } from '../mock';

export default function Faq() {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="scroll-mt-24 px-4 sm:px-6 py-16 sm:py-20 md:py-28">
      <div className="max-w-[1360px] mx-auto">
        <h2 className="font-display uppercase text-[40px] sm:text-[52px] md:text-[64px] leading-[1] tracking-[-0.015em] text-[color:var(--alfa-navy)]">
          Straight<br />
          <span className="text-[color:var(--alfa-royal)]">answers.</span>
        </h2>

        <div className="mt-10 sm:mt-12 max-w-4xl">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={f.q} className="faq-item">
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between py-5 sm:py-7 text-left gap-4"
                >
                  <span className="font-display uppercase text-[18px] sm:text-[21px] md:text-[22px] text-[color:var(--alfa-navy)] pr-4 sm:pr-8">
                    {f.q}
                  </span>
                  <span className="shrink-0 w-8 h-8 sm:w-9 sm:h-9 rounded-full border border-neutral-900 flex items-center justify-center text-neutral-900">
                    {isOpen ? <Minus size={16} /> : <Plus size={16} />}
                  </span>
                </button>
                <div
                  className="overflow-hidden transition-[max-height] duration-500"
                  style={{ maxHeight: isOpen ? '560px' : '0px' }}
                >
                  <p className="pb-6 sm:pb-7 pr-4 sm:pr-12 text-[15.5px] sm:text-[16.5px] text-neutral-950 leading-relaxed">
                    {f.a}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
